import { eCapitalFundType } from "../helpers/udmConstants";

const defaultAmount = 0.0;

const generateAsset = (inputs) => {
    const defaults = {
        "deathBenefitAmount": defaultAmount,
        "existingLifeInsurance": defaultAmount,
        "nonregisteredInvestmentAmount": defaultAmount,
        "otherAsset": defaultAmount,
        "principalResidenceAmount": defaultAmount,
        "registeredInvestmentAmount": defaultAmount,
        "savingAmount": defaultAmount,
        "taxFreeSavingAmount": defaultAmount,
        "totalAssetAmount": defaultAmount,
        "availableSavingAmount": defaultAmount,
        "existingInsuranceAmount": defaultAmount
    }
    return {
        ...defaults,
        ...inputs
    }
};
const generateExpense = (inputs) => {
    const defaults = {
        "childCount": defaultAmount,
        "debtsAmount": defaultAmount,
        "educationAmount": defaultAmount,
        "educationTotalAmount": defaultAmount,
        "educationYear": defaultAmount,
        "finalExpenseAmount": defaultAmount,
        "homeCareAmount": defaultAmount,
        "homeCareChildCount": defaultAmount,
        "homeCareTotalAmount": defaultAmount,
        "homeCareYear": defaultAmount,
        "otherCashAmount": defaultAmount,
        "rentAmount": defaultAmount,
        "totalAmount": defaultAmount,
        "additionalExpense": defaultAmount,
        "debtsMonthCount": defaultAmount,
        "debtsTotalAmount": defaultAmount,
        "livingExpense": defaultAmount,
        "livingMonthCount": defaultAmount,
        "livingTotalAmount": defaultAmount,
        "lumpSumPayment": defaultAmount,
        "rentMonthCount": defaultAmount,
        "rentTotalAmount": defaultAmount,
        "savingContribution": defaultAmount,
        "savingMonthCount": defaultAmount,
        "savingTotalAmount": defaultAmount
    }
    return {
        ...defaults,
        ...inputs
    }
};
const generateIncome = (inputs) => {
    const defaults = {
        "capitalFund": eCapitalFundType.deplete,
        "benefitAmount": defaultAmount,
        "extraIncomeYear": defaultAmount,
        "familyIncomePercentage": 0,
        "householdIncomeAmount": defaultAmount,
        "partnerAvailableIncome": defaultAmount,
        "returnRatePercentage": 0,
        "shortageAmount": defaultAmount,
        "totalIncomeAmount": defaultAmount,
        "totalFamilyIncome": defaultAmount,
        "replaceIncome": defaultAmount,
        "replaceMonthCount": defaultAmount,
        "replacePartnerIncome": defaultAmount,
        "replacePartnerMonthCount": defaultAmount,
        "totalPartnerIncome": defaultAmount,
        "totalRequiredAmount": defaultAmount,
        "totalReplaceIncome": defaultAmount,
        "averageTaxRate": 0,
        "employmentStatus": null,
        "maxInsuranceLimit": defaultAmount,
        "monthlyIncome": 0,
        "monthlyInsuranceAmount": defaultAmount,
        "monthlyNonTaxableBenefit": defaultAmount,
        "monthlyTaxableBenefit": defaultAmount,
        "otherMonthlyIncome": defaultAmount
    }
    return {
        ...defaults,
        ...inputs
    }
};
export const generateLife = (partyId, age, healthstyle, assetInputs, expenseInputs, incomeInputs) => {
    return {
        partyId,
        age,
        healthstyle,
        asset: generateAsset(assetInputs),
        expense: generateExpense(expenseInputs),
        income: generateIncome(incomeInputs)
    }
};